import {Component, Input, OnChanges} from '@angular/core';
import {UnitDemandModel} from '../../dashboard/monitoring/unit-demand.model';
import {combineLatest, Observable} from 'rxjs';
import {Unit} from '../../dashboard/monitoring/unit';
import {AuthorizationService} from '../../authorization/authorization.service';
import {map} from 'rxjs/operators';
import {StatisticBarStyleModel} from '../../shared/statistic-bar/statistic-bar-style.model';
import {timestampToDateTimeWithoutComma} from '../../utility/timestamp-functions';

@Component({
  selector: 'app-unit-demand-info',
  templateUrl: './unit-demand-info.component.html',
  styleUrls: ['./unit-demand-info.component.scss']
})
export class UnitDemandInfoComponent implements OnChanges {
  public readonly timestampToDateTimeWithoutComma = timestampToDateTimeWithoutComma;
  @Input() unitDemands: Observable<UnitDemandModel[]> | null;
  @Input() status: string;
  @Input() styleBarType: StatisticBarStyleModel;
  demandVisibility = new Observable<boolean>();

  constructor(
    private authorizationService: AuthorizationService
  ) {
  }

  ngOnChanges() {
    this.demandVisibility = combineLatest([
      this.authorizationService.canAccessSharingFeatures(),
      this.unitDemands,
    ]).pipe(
      map(([canAccess, demands]) => {
        return canAccess && demands.length > 0 && this.status === Unit.STATUS_ORDER_GRID_FREE;
      })
    );
  }
}
